/**
 * Warstwa API: STOPKI E-MAIL — mapowanie per spółka, historia wersji wzoru, archiwum (S4, 2026-09-14).
 *
 * Trasy backendu (`EmailSignaturesController`, klucz `AdminEmailSignatures`):
 *   GET  api/email-signatures/company-mapping
 *   GET  api/email-signatures/templates/{id}/versions
 *   GET  api/email-signatures/templates/{id}/versions/{wersjaId}
 *   POST api/email-signatures/templates/{id}/versions/{wersjaId}/restore
 *   POST api/email-signatures/templates/{id}/unarchive
 *
 * Istniejące metody wzoru (getSignatureTemplate, createSignatureTemplate, updateSignatureTemplate,
 * deleteSignatureTemplate — dziś ARCHIWUM, nie kasowanie) zostają w apiService.js; ten plik tylko dokłada nowe.
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js i zwraca nazwane metody doczepiane do wspólnego
 * `apiService`. Nazwy muszą być unikalne w całej aplikacji — kolizja zatrzymuje start (patrz attachApiModules).
 */
export function attach(api) {
    return {
        /** Spółka → obowiązujący wzór (wlasny | globalny | brak), wiersz wzoru globalnego i archiwum. */
        getSignatureCompanyMapping: () => api.get("/email-signatures/company-mapping"),

        /** Historia wersji wzoru od najnowszej — bez bloków (lekka lista do szuflady). */
        getSignatureTemplateVersions: (templateId) =>
            api.get(`/email-signatures/templates/${templateId}/versions`),

        /** Jedna wersja z blokami — podgląd przed przywróceniem. */
        getSignatureTemplateVersion: (templateId, versionId) =>
            api.get(`/email-signatures/templates/${templateId}/versions/${versionId}`),

        /** „Przywróć”: treść wersji wraca do wzoru i od razu obowiązuje; serwer dopisuje NOWĄ wersję. */
        restoreSignatureTemplateVersion: (templateId, versionId) =>
            api.post(`/email-signatures/templates/${templateId}/versions/${versionId}/restore`),

        /** Wyjęcie wzoru z archiwum — dotychczasowy wzór tej spółki idzie do archiwum. */
        unarchiveSignatureTemplate: (templateId) =>
            api.post(`/email-signatures/templates/${templateId}/unarchive`),
    };
}
